/* spring-feature-columns — Read-more disclosure for clamped card bodies.
   Link-less cards render a real <button> that expands the 2-line clamp in
   place ("Read more" <-> "Read less"). The button is only surfaced when the
   body actually overflows two lines. Linked cards use a static span instead
   (the whole <a> card navigates) and are left untouched here. */
(function () {
  const TAG = 'spring-feature-columns';

  class SpringFeatureColumns extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(
        this.querySelectorAll('button.spring-feature-columns__readmore')
      );
      this.toggles.forEach((btn) => {
        btn.addEventListener('click', () => this.toggle(btn));
      });

      this.sync = this.sync.bind(this);
      this.sync();
      window.addEventListener('resize', this.sync, { passive: true });
      if (document.readyState !== 'complete') {
        window.addEventListener('load', this.sync, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.sync);
    }

    toggle(btn) {
      const body = btn.previousElementSibling;
      if (!body) return;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      body.classList.toggle('is-expanded', !expanded);
      btn.textContent = expanded ? 'Read More' : 'Read Less';
    }

    sync() {
      this.toggles.forEach((btn) => {
        if (btn.getAttribute('aria-expanded') === 'true') return;
        const body = btn.previousElementSibling;
        if (!body) return;
        const overflows = body.scrollHeight - body.clientHeight > 2;
        btn.hidden = !overflows;
      });
    }
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, SpringFeatureColumns);
  }
})();
